export const regranulatyStepsAccordion = () => {
  const roots = Array.from(document.querySelectorAll(".hero-modal"));
  if (!roots.length) return;

  const initOne = (root) => {
    const items = Array.from(root.querySelectorAll(".item[data-item]"));
    const panels = Array.from(root.querySelectorAll(".hero-modal__panel"));

    if (!items.length || !panels.length) return;

    const getPanelById = (id, group) =>
      root.querySelector(
        `.hero-modal__panel[data-panel="${id}"][data-group="${group}"]`,
      );

    const getItemById = (id, group) =>
      root.querySelector(`.item[data-item="${id}"][data-group="${group}"]`);

    const orderedEntries = items
      .map((item) => {
        const id = item.getAttribute("data-item");
        const group = item.getAttribute("data-group");
        const panel = getPanelById(id, group);

        if (!id || !group || !panel) return null;

        return { id, group, panel, item };
      })
      .filter(Boolean);

    const findEntryIndex = (id, group) =>
      orderedEntries.findIndex(
        (entry) => entry.id === String(id) && entry.group === String(group),
      );

    const openByIndex = (index) => {
      if (!orderedEntries.length) return;

      const safeIndex =
        ((index % orderedEntries.length) + orderedEntries.length) %
        orderedEntries.length;

      const entry = orderedEntries[safeIndex];
      open(entry.id, entry.group);
    };

    const closeAll = () => {
      panels.forEach((panel) => {
        panel.hidden = true;
      });

      items.forEach((item) => {
        item.classList.remove("is-active");
        const btn = item.querySelector(".item__btn");
        if (btn) btn.setAttribute("aria-expanded", "false");
      });
    };

    const open = (id, group) => {
      const panel = getPanelById(id, group);
      const item = getItemById(id, group);

      if (!panel || !item) return;

      closeAll();

      panel.hidden = false;
      item.classList.add("is-active");

      const btn = item.querySelector(".item__btn");
      if (btn) btn.setAttribute("aria-expanded", "true");

      // opcjonalnie: scroll do otwartego panelu
      panel.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    };

    items.forEach((item) => {
      item.addEventListener("click", (e) => {
        const link = e.target.closest("a");
        if (link) return;

        const isBtn = e.target.closest(".item__btn");
        if (isBtn) return;

        const id = item.getAttribute("data-item");
        const group = item.getAttribute("data-group");
        open(id, group);
      });

      const btn = item.querySelector(".item__btn");
      if (btn) {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          const id = item.getAttribute("data-item");
          const group = item.getAttribute("data-group");
          open(id, group);
        });
      }
    });

    panels.forEach((panel) => {
      const id = parseInt(panel.getAttribute("data-panel"), 10);
      const group = panel.getAttribute("data-group");

      const collapse = panel.querySelector(".hero-modal__collapse");
      const collapse2 = panel.querySelector(".hero-modal__close-mobile");
      if (collapse) {
        collapse.addEventListener("click", () => {
          closeAll();
        });
      }
      if (collapse2) {
        collapse2.addEventListener("click", () => {
          closeAll();
        });
      }
      const prev = panel.querySelector("[data-prev]");
      if (prev) {
        prev.addEventListener("click", () => {
          const currentIndex = findEntryIndex(id, group);
          if (currentIndex === -1) return;
          openByIndex(currentIndex - 1);
        });
      }

      const next = panel.querySelector("[data-next]");
      if (next) {
        next.addEventListener("click", () => {
          const currentIndex = findEntryIndex(id, group);
          if (currentIndex === -1) return;
          openByIndex(currentIndex + 1);
        });
      }
    });

    document.addEventListener("keydown", (e) => {
      const openedPanel = panels.find((panel) => !panel.hidden);
      if (!openedPanel) return;

      const id = parseInt(openedPanel.getAttribute("data-panel"), 10);
      const group = openedPanel.getAttribute("data-group");
      const currentIndex = findEntryIndex(id, group);
      if (currentIndex === -1) return;

      if (e.key === "Escape") {
        closeAll();
      }

      if (e.key === "ArrowLeft") {
        openByIndex(currentIndex - 1);
      }

      if (e.key === "ArrowRight") {
        openByIndex(currentIndex + 1);
      }
    });

    closeAll();
  };

  roots.forEach(initOne);
};
